import { useQuery } from "@tanstack/react-query";
import JobPostCaterAPI from "@frontend/app/api/JobPostCaterAPI.ts";

async function fetchCater(id: string) {
  const response = await JobPostCaterAPI.get(id);
  if (!!response.error) {
    throw new Error(response.error || "Failed to fetch cater");
  }
  return response;
}

const useJobPostCater = (id: string) =>
  useQuery({
    queryKey: ["jobPostCater", id],
    queryFn: () => fetchCater(id),
  });

export default useJobPostCater;
